var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditsPolygonBorder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 164,
    viewBox: "0 0 148 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_142_1996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.1 3.87047C69.4637 -0.380994 78.5363 -0.380991 85.9 3.87047L135.712 32.6295C143.076 36.881 147.612 44.738 147.612 53.2409V110.759C147.612 119.262 143.076 127.119 135.712 131.37L85.9 160.13C78.5362 164.381 69.4637 164.381 62.1 160.13L12.2878 131.37C4.92409 127.119 0.38784 119.262 0.38784 110.759V53.2409C0.38784 44.738 4.9241 36.881 12.2878 32.6295L62.1 3.87047Z",
    fill: "white",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8708 6.93764C70.1388 3.31884 77.8612 3.31884 84.1292 6.93764L133.941 35.6967C140.209 39.3155 144.07 46.0033 144.07 53.2409V110.759C144.07 117.997 140.209 124.684 133.941 128.303L84.1292 157.062C77.8612 160.681 70.1388 160.681 63.8708 157.062L14.0587 128.303C7.79072 124.684 3.92951 117.997 3.92951 110.759V53.2409C3.92951 46.0033 7.79072 39.3155 14.0587 35.6967L63.8708 6.93764Z",
    stroke: "#FDDE3D",
    strokeWidth: 7.08333
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_142_1996",
    x: -18.7134,
    y: -18.4192,
    width: 185.427,
    height: 200.838,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9.55056
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_142_1996"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_142_1996",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditsPolygonBorder);
export default __webpack_public_path__ + "static/media/credits-polygon-border.cdcf25d49c19f1b3ffabc951becd25b2.svg";
export { ForwardRef as ReactComponent };